import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import ScrollToTop from "../../ScrollToTop";
import { RxHamburgerMenu } from "react-icons/rx";
import { FaUser } from "react-icons/fa";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const Header = () => {
  const [token, setToken] = useState()
  const { cartItems } = useSelector((state) => state.cartSlice)
  console.log(cartItems)


  const tokenD = window.localStorage.getItem("token");
  useEffect(() => {
    setToken(tokenD)
  }, [tokenD])
  const navigate = useNavigate();

  const logout = () => {
    const id = toast.loading("Logging out...");
    setTimeout(() => {

      window.localStorage.removeItem("token");
      navigate("/login")
      toast.success("Logged out successfully", { id });
    }, 1000);
  }

  function addClass() {
    const nav = document.querySelector(".navbar");
    nav.classList.toggle("active");
  }
  function removeClass() {
    const nav = document.querySelector(".navbar");
    nav.classList.remove("active");
  }
  return (
    <>
      {/* <ScrollToTop /> */}
      <header className="header">
        <div className="logo">
          <Link to="/">
            <img
              src="/./Images/tulika-logo.jpg"
              alt="Website Logo"
              style={{ borderRadius: 12 }}
            />
          </Link>
          <div className="hamburger_menu">
            <RxHamburgerMenu className="icon" onClick={addClass} />
          </div>
        </div>
        <div className="navbar">
          <nav className="nav-links">
            <NavLink onClick={removeClass} to="/">Home</NavLink>
            <NavLink onClick={removeClass} to="/gallary">Gallery</NavLink>
            <NavLink onClick={removeClass} to="/shop/mithila-buddha">Shop Now</NavLink>
            <NavLink onClick={removeClass} to="/about-us">About Us</NavLink>
            <NavLink onClick={removeClass} to="/contact-us">Contact Us</NavLink>
          </nav>
          <div className="social-icons">
            <p className="social-icon" style={{ marginBottom: "0px" }}>
              <a
                target="_blank"
                href="https://www.facebook.com/people/Tulika/100067604133894/?mibextid=ZbWKwL"
                className="fa fa-facebook"
                title="facebook"
              />
              <a
                target="_blank"
                href="https://www.instagram.com/tulika.art.creations/"
                className="fa fa-instagram"
                title="instagram"
              />
              <a

                href="https://wa.me/9869261077"
                className="fa fa-whatsapp"
                title="WhatsApp"
                target="_blank"
                rel="noopener noreferrer"
              >
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/@rishabh_nishad"
                className="fa fa-youtube-play"
                title="youtube"
              />
            </p>
            {
              token && <Link to='/dashboard'> <FaUser size={20} /></Link>
            }
            {
              token ? <Link onClick={logout} ><button className="login-button">Logout</button></Link> : <Link to='login'><button className="login-button">Login</button></Link>
            }

            <NavLink to="/cart" className="position-relative">
              <a href="#" className="fa fa-shopping-cart fs-4 " title="Cart" />
              {cartItems.length > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                >
                  {cartItems.length}
                </span>
              )}
            </NavLink>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
